import * as actionTypes from './actionTypes';

export const addToCart = item => ({
    type: actionTypes.ADD_TO_CART,
    item
});

export const deleteFromCart = id => ({
   type: actionTypes.DELETE_FROM_CART,
   id
});

export const getCartItems = () => ({
    type: actionTypes.GET_CART_DATA
});
